import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { IonModal, IonHeader, IonContent } from '@ionic/react'
import i18n from 'i18next'
import './index.scss'

interface IProps {
  children?: any;
  reject?: () => void;
}

const ActivityDetailModal: FC<IProps> = (props: IProps) => {
  const { children, reject } = props
  return (
    <IonModal
      cssClass='activity-detail-modal'
      isOpen
      showBackdrop
      backdropDismiss
      onDidDismiss={reject}
    >
      <IonHeader className='modal-header'>
        <span>{i18n.t('mkt.market.marketDetail')}</span>
        <i className='iconfont icon-close' onClick={reject}></i>
      </IonHeader>
      <IonContent>
        <div className='modal-body'>{children && children}</div>
      </IonContent>
    </IonModal>
  )
}

export default observer(ActivityDetailModal)
